module.exports = __webpack_public_path__ + "assets/img/edit.9630e093.svg";